export default {
    WHITE: 'FFFFFF',
    TURQUOISE: '00D1D2',
    BLUE: '0AB1FF',
    YELLOW: 'FDDB6D',
};
